<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Grupos
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="search"
        multi-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
        <template v-slot:top>
          <div class="py-2 px-2 table_search_area">
            <v-text-field
              clearable
              hide-details=""
              clear-icon="close"
              v-model="search"
              outlined
              label="Busca"
            ></v-text-field>
          </div>
        </template>
        <template v-slot:item.gru_modulos="{ item }">
          <span v-for="(iten, index) in item.gru_modulos" :key="index">
            {{iten.mod_nome}}{{item.gru_modulos.length === index + 1 ? '.' : ', '}}
          </span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openNovo(item)" color="primary" class="mr-2">
                  edit
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="550px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{grupo.uuid_gru_id ? 'Editar grupo' : 'Novo grupo'}}
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formGrupos">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="grupo.gru_modulos"
                :items="modulos"
                clearable
                multiple
                clear-icon="close"
                label="Módulos de acesso*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingModules"
                :disabled="salvando || loadingModules"
                outlined
              >
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item v-on="on" v-bind="attrs">
                    <v-list-item-icon>
                      <v-icon>
                        {{ grupo.gru_modulos.includes(item.value) ? 'check_box' : 'check_box_outline_blank' }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text" class="text-left"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-text-field
                v-model="grupo.gru_nome"
                label="Nome*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditGroup()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Grupo
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelGrupoDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Grupo <b class="text-primary">{{grupo.gru_nome}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            @click="cancelGrupoDelete()"
            :loading="salvando"
            :disabled="salvando"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeGroup()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogExcluir: false,
      loadingModules: false,
      search: '',
      modulos: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'gru_id'
        },
        { text: 'Nome', value: 'gru_nome' },
        { text: 'Módulos', value: 'gru_modulos' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      rules: {
        required: value => !!value || 'Obrigatório.'
      },
      grupo: {
        gru_modulos: [],
        gru_nome: ''
      }
    }
  },
  methods: {
    loadFunctions () {
      this.getModules()
      this.getGroups()
    },
    async getModules () {
      this.loadingModules = true
      await Api.get('modulos')
        .then(res => {
          var arrayModulos = []
          res.data.map(mod => {
            arrayModulos.push({
              'text': mod.mod_nome,
              'value': mod.uuid_mod_id
            })
          })
          this.modulos = arrayModulos
          this.loadingModules = false
        })
        .catch(err => {
          this.loadingModules = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os módulos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getGroups () {
      this.loading = true
      await Api.get('grupos')
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                gru_id: item.gru_id,
                gru_nome: item.gru_nome,
                gru_modulos: item.modulos ? item.modulos : [],
                uuid_gru_id: item.uuid_gru_id
              })
            })
            this.dados = info
            console.log(this.dados)
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os grupos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    saveEditGroup () {
      if (!this.$refs.formGrupos.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'grupos/novo'
      let editado = false
      if (this.grupo.uuid_gru_id) {
        endpoint = 'grupos/edita'
        editado = true
      }
      if (this.grupo.gru_modulos.length > 0) {
        let modulos = []
        this.grupo.gru_modulos.map(mod => {
          modulos.push({
            'uuid_mod_id': mod
          })
        })
        this.grupo.gru_modulos = modulos
      }
      Api.post(endpoint, this.grupo)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Grupo atualizado com sucesso!' : 'Grupo cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getGroups()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeGroup () {
      this.salvando = true
      Api.delete(`grupos/remove/${this.grupo.uuid_gru_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getGroups()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover grupo!',
            color: 'error'
          })
        })
    },
    openNovo (item) {
      this.grupo = JSON.parse(JSON.stringify(item))
      if (this.grupo.gru_modulos.length) {
        let modulos = []
        this.grupo.gru_modulos.map(mod => {
          modulos.push(mod.uuid_mod_id)
        })
        this.grupo.gru_modulos = modulos
      }
      this.dialogNovo = true
    },
    cancelGrupoDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    openDialogDelete (item) {
      this.grupo = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    closeDialog () {
      this.grupo = {
        gru_modulos: [],
        gru_nome: ''
      }
      if (this.$refs.formGrupos) {
        this.$refs.formGrupos.resetValidation()
      }
      this.dialogNovo = false
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/pages/gestor/Grupos.vue